import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AccountDetailUI from './AccountDetailUI.js'
import CacheManager from '../../../cache/CacheManager.js'
import CacheKeys from '../../../cache/CacheKeys.js'

class AccountDetailSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gstSubmitted: false,
      gstSuccessMsg: null,
      gstErrorList: [],
      accountList: [],
      accountDescUpdateMode: false,
      accountStatusUpdateMode: false,
      companyNameUpdateMode: false,
      assignedUserMode: false,
      womanLedMode: false,
      addressUpdateMode: false,
      addMode: false,
      depositAddMode: false,
      lenderUpdateMode: false,
      nachUpdateMode: false,
      updateGuarantorMode: false,
      panValidationMode: false,
      phoneNumberUpdateMode: false,
      emailUpdateMode: false,
      appOnboardingStatusUpdateMode: false,
    }
  }

  render() {

    const accountKeyValueList = this.state.accountList.map((account) => ({
      key: account.accountId,
      value: account.accountName,
    }));

    console.log(accountKeyValueList)

    return (
      <AccountDetailUI
        context={this.props.context}
        account={this.props.account}
        copyToClipboardText={this.props.copyToClipboardText}
        onCopyToClipboard={this.props.onCopyToClipboard}
        onRefreshClick={this.props.onRefreshClick}
        // gst from panNumber
        gstSubmitted={this.state.gstSubmitted}
        gstSuccessMsg={this.state.gstSuccessMsg}
        gstErrorList={this.state.gstErrorList}
        // pan from panNumber
        panSubmitted={this.state.panSubmitted}
        panSuccessMsg={this.state.panSuccessMsg}
        panErrorList={this.state.panErrorList}
        accountList={this.state.accountList}
        accountKeyValueList={accountKeyValueList}
        onApplyGSTSubmit={this.onApplyGSTSubmit}
        //
        onAccountDescUpdateClick={() => { this.setState({ accountDescUpdateMode: true }) }}
        accountDescUpdateMode={this.state.accountDescUpdateMode}
        onAccountDescUpdateCancel={() => { this.setState({ accountDescUpdateMode: false }) }}
        //
        accountStatusUpdateMode={this.state.accountStatusUpdateMode}
        onAccountStatusUpdateClick={() => { this.setState({ accountStatusUpdateMode: true }) }}
        onAccountStatusUpdateCancel={() => { this.setState({ accountStatusUpdateMode: false }) }}
        //
        onCompanyNameUpdateClick={() => { this.setState({ companyNameUpdateMode: true }) }}
        companyNameUpdateMode={this.state.companyNameUpdateMode}
        onCompanyNameUpdateCancel={() => { this.setState({ companyNameUpdateMode: false }) }}
        //
        onAddressUpdateClick={() => { this.setState({ addressUpdateMode: true }) }}
        addressUpdateMode={this.state.addressUpdateMode}
        onAddressUpdateCancel={() => { this.setState({ addressUpdateMode: false }) }}
        //
        assignedUserMode={this.state.assignedUserMode}
        onAssignedUserClick={() => this.setState({ assignedUserMode: true })}
        onAssignedUserCancel={() => this.setState({ assignedUserMode: false })}
        //
        womanLedMode={this.state.womanLedMode}
        onWomanLedClick={() => { this.setState({ womanLedMode: true }) }}
        onWomanLedCancel={() => { this.setState({ womanLedMode: false }) }}
        //
        addMode={this.state.addMode}
        onAddGSTClick={() => { this.setState({ addMode: true }) }}
        onAddGSTCancelClick={() => { this.setState({ addMode: false }) }}
        //
        depositAddMode={this.state.depositAddMode}
        onAddSecurityDepositClick={() => { this.setState({ depositAddMode: true }) }}
        onAddSecurityDepositCancelClick={() => { this.setState({ depositAddMode: false }) }}
        //
        lenderUpdateMode={this.state.lenderUpdateMode}
        onLenderUpdateClick={() => { this.setState({ lenderUpdateMode: true }) }}
        onLenderUpdateCancelClick={() => { this.setState({ lenderUpdateMode: false }) }}
        //
        nachUpdateMode={this.state.nachUpdateMode}
        onNachUpdateClick={() => { this.setState({ nachUpdateMode: true }) }}
        onNachUpdateCancelClick={() => { this.setState({ nachUpdateMode: false }) }}
        //
        updateGuarantorMode={this.state.updateGuarantorMode}
        onGuarantorUpdateClick={() => { this.setState({ updateGuarantorMode: true }) }}
        onGuarantorUpdateCancel={() => { this.setState({ updateGuarantorMode: false }) }}
        //
        panValidationMode={this.state.panValidationMode}
        onPanValidationClick={() => { this.setState({ panValidationMode: true }) }}
        onPanValidationCancel={() => { this.setState({ panValidationMode: false }) }}
        //
        phoneNumberUpdateMode={this.state.phoneNumberUpdateMode}
        onPhoneNumberUpdateClick={() => { this.setState({ phoneNumberUpdateMode: true }) }}
        onPhoneNumberUpdateCancel={() => { this.setState({ phoneNumberUpdateMode: false }) }}
        //
        emailUpdateMode={this.state.emailUpdateMode}
        onEmailUpdateClick={() => { this.setState({ emailUpdateMode: true }) }}
        onEmailUpdateCancel={() => { this.setState({ emailUpdateMode: false }) }}
        //
        appOnboardingStatusUpdateMode={this.state.appOnboardingStatusUpdateMode}
        onAppOnboardingStatusUpdateClick={() => { this.setState({ appOnboardingStatusUpdateMode: true }) }}
        onAppOnboardingStatusUpdateCancel={() => { this.setState({ appOnboardingStatusUpdateMode: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getConnectedAccounts(context, context.filter)
  }

  getConnectedAccounts(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts`,
      cacheKey: CacheKeys.Accounts(stp),
      callback: this.getConnectedAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { stp: stp === 'stp' ? true : false })
  }

  getConnectedAccountsCallback = (response) => {
    this.setState({ errorList: response.errorList, accountList: response.accountList })
  }

  onApplyGSTSubmit = () => {
    let gstSubmitted = this.state.gstSubmitted
    if (gstSubmitted)
      return

    this.setState({
      gstSuccessMsg: null,
      gstErrorList: [],
      gstSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/pan/gst`,
      this.onApplyGSTSubmitCallback, {}
    )
  }

  onApplyGSTSubmitCallback = (response) => {
    let gstErrorList = []
    response.errorList.forEach(error => {
      gstErrorList.push(error.message)
    })

    this.setState({
      gstSuccessMsg: response.success,
      gstErrorList: gstErrorList,
      gstSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ gstSuccessMsg: null })
        this.props.onRefreshClick()
      }, 2000)
    }
  }
}

export default AccountDetailSF
